import {
  Box,
  Card,
  CardContent,
  GridLegacy as Grid,
  Skeleton,
  Stack,
} from '@mui/material';
import React from 'react';

import {
  HOME_SECTION_SLOTS,
  LISTING_IMAGE_ASPECT_PADDING,
  listingVisibilitySx,
} from '../../config/homePage';

const LOCATION_ROW_HEIGHT = 24;
const CAPACITY_ROW_HEIGHT = 20;

const VIEW_BUTTON_HEIGHT = 42;

const ListingCardSkeleton: React.FC = () => (
  <Card
    sx={{ borderRadius: '20px', flexShrink: 0, height: '100%' }}
    data-cy="listing-card-skeleton"
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          paddingBottom: LISTING_IMAGE_ASPECT_PADDING,
          flexGrow: 0,
          overflow: 'hidden',
        }}
      >
        <Skeleton
          variant="rectangular"
          sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}
        />
      </Box>
      <CardContent sx={{ position: 'relative', flexGrow: 1 }}>
        <Grid
          container
          spacing={3}
          sx={{
            height: '100%',
            marginTop: 0,
            position: 'relative',
            paddingBottom: '40px',
          }}
        >
          <Grid item xs={10} sx={{ flexGrow: 0 }}>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{ height: LOCATION_ROW_HEIGHT }}
            >
              <Skeleton variant="circular" width={20} height={20} />
              <Skeleton
                variant="text"
                width="70%"
                sx={{ fontSize: '0.8rem' }}
              />
            </Stack>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{ height: CAPACITY_ROW_HEIGHT }}
            >
              <Skeleton variant="circular" width={18} height={18} />
              <Skeleton
                variant="text"
                width="55%"
                sx={{ fontSize: '0.8rem' }}
              />
            </Stack>
          </Grid>
          <Grid item xs={2}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
              sx={{ height: LOCATION_ROW_HEIGHT }}
            >
              <Skeleton variant="text" width={28} sx={{ fontSize: '0.8rem' }} />
            </Stack>
          </Grid>
          <Grid item xs={12} sx={{ flexGrow: 1 }}>
            <Skeleton
              variant="text"
              width="85%"
              sx={{
                fontSize: '1.2rem',
                lineHeight: 1.2,
                marginBottom: '1.3rem',
              }}
            />
            <Skeleton
              variant="text"
              width="45%"
              sx={{ fontSize: '0.8rem', lineHeight: 1.2 }}
            />
          </Grid>
          <Grid item xs={12} sx={{ flexGrow: 0, padding: 0, height: 0 }}>
            <Box
              sx={{
                position: 'absolute',
                bottom: 0,
                width: 'calc(100% - 12px)',
              }}
            >
              <Skeleton
                variant="rounded"
                height={VIEW_BUTTON_HEIGHT}
                sx={{ borderRadius: '20px' }}
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Box>
  </Card>
);

interface ListingCardSkeletonGridProps {
  count?: number;
}

export const ListingCardSkeletonGrid: React.FC<
  ListingCardSkeletonGridProps
> = ({ count = HOME_SECTION_SLOTS }) => (
  <React.Fragment>
    {Array.from({ length: count }, (_, index) => (
      <Grid
        item
        xs={12}
        sm={4}
        lg={3}
        key={`listing-skeleton-${index}`}
        sx={
          index < count - 1 ? listingVisibilitySx(index, count - 1) : undefined
        }
      >
        <ListingCardSkeleton />
      </Grid>
    ))}
  </React.Fragment>
);

export default ListingCardSkeleton;
